import { CreateSpeaker } from '@/types/speakers.types';

const createDefaultSpeaker = (props?: Partial<CreateSpeaker>): CreateSpeaker => ({
  first_name: '',
  last_name: '',
  description: {
    base: '',
    changed: '',
  },
  image: '',
  original_image: '',
  link_social: true,
  social_links: [
    {
      platform: '',
      url: '',
    },
  ],
  attributes_enabled: true,
  attributes: [],
  job_title: {
    base: '',
    changed: '',
  },
  ...props,
});

export default createDefaultSpeaker;
